/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Uptime_ColumnInputs */

const en_endpoint_uptime_column = /** @type {(inputs: Endpoint_Uptime_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uptime`)
};

const zh_hans1_endpoint_uptime_column = /** @type {(inputs: Endpoint_Uptime_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可用率`)
};

const pt_br2_endpoint_uptime_column = /** @type {(inputs: Endpoint_Uptime_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilidade`)
};

const es_endpoint_uptime_column = /** @type {(inputs: Endpoint_Uptime_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilidad`)
};

const fr_endpoint_uptime_column = /** @type {(inputs: Endpoint_Uptime_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilité`)
};

const de_endpoint_uptime_column = /** @type {(inputs: Endpoint_Uptime_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbarkeit`)
};

const ru_endpoint_uptime_column = /** @type {(inputs: Endpoint_Uptime_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступность`)
};

const it_endpoint_uptime_column = /** @type {(inputs: Endpoint_Uptime_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilità`)
};

/**
* | output |
* | --- |
* | "Uptime" |
*
* @param {Endpoint_Uptime_ColumnInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_uptime_column = /** @type {((inputs?: Endpoint_Uptime_ColumnInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Uptime_ColumnInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_uptime_column(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_uptime_column(inputs)
	if (locale === "es") return es_endpoint_uptime_column(inputs)
	if (locale === "fr") return fr_endpoint_uptime_column(inputs)
	if (locale === "de") return de_endpoint_uptime_column(inputs)
	if (locale === "ru") return ru_endpoint_uptime_column(inputs)
	if (locale === "it") return it_endpoint_uptime_column(inputs)
	return en_endpoint_uptime_column(inputs)
});